import React from 'react';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Table, Grid, ChevronUp, PlusCircle, BarChart2 } from 'react-feather';

const MappingsTopHead = ({ tileView, onToggleView, onCollapse, collapsed, onAddNewShipment, onViewReport }) => {
  const renderTileViewTooltip = props => (
    <Tooltip {...props}>{tileView ? 'Table View' : 'Tile View'}</Tooltip>
  );
  const renderCollapseTooltip = props => <Tooltip {...props}>Collapse</Tooltip>;

  return (
    <>
      <ul className="table-top-head">
        <li>
          <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
            <Link
              to="#"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              id="collapse-header"
              className={collapsed ? 'active' : ''}
              onClick={onCollapse}
            >
              <ChevronUp />
            </Link>
          </OverlayTrigger>
        </li>
        <li>
          <OverlayTrigger placement="top" overlay={renderTileViewTooltip}>
            <Link
              to="#"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              onClick={(e) => {
                e.preventDefault();
                onToggleView(!tileView);
              }}
            >
              {tileView ? <Table /> : <Grid />}
            </Link>
          </OverlayTrigger>
        </li>
      </ul>
      <div className="d-flex purchase-pg-btn">
        <div className="page-btn">
          <button
            className="btn btn-outline-info"
            onClick={onViewReport}
          >
            <BarChart2 className="me-2" />
            View Report
          </button>
        </div>
        <div className="page-btn">
          <button
            className="btn btn-added"
            onClick={onAddNewShipment}
          >
            <PlusCircle className="me-2" />
            Add New Shipment
          </button>
        </div>
      </div>
    </>
  );
};

export default MappingsTopHead;
